import styled from "styled-components";

const Grid = styled.div`
  display: grid;
  gap: ${(p) => p.$gap}px;

  /* cols を指定できる */
  grid-template-columns: repeat(${(p) => p.$cols}, minmax(0, 1fr));

  /* 画面が狭いときは自動で崩す（崩したくなければ削除OK） */
  @media (max-width: 900px) {
    grid-template-columns: repeat(${(p) => Math.min(p.$cols, 2)}, minmax(0, 1fr));
  }
  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`;

export function FeatureTileGrid({
  cols = 2,
  gap = 12,
  children,
  ...rest
}) {
  const safeCols = Math.max(1, Number(cols) || 1);
  const safeGap = Math.max(0, Number(gap) || 0);

  return (
    <Grid $cols={safeCols} $gap={safeGap} {...rest}>
      {children}
    </Grid>
  );
}
